import { render, staticRenderFns } from "./categoryDetail.vue?vue&type=template&id=38b876ac&"
import script from "./categoryDetail.vue?vue&type=script&lang=js&"
export * from "./categoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./categoryDetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports